/**
 * Campos de precio VIP para Slack / PostHog en DualCTA.
 * Separa "checkout route" de stripe price_ y copy mostrado al usuario.
 */

import {
  formatCouponHint,
  formatDualCtaFirstMonthOffer,
} from "@/lib/dualCtaPriceDisplay";

export type DualCtaVipStripePriceSource =
  | "ab_slot"
  | "country_admin"
  | "dashboard"
  | "canonical"
  | "server_lookup";

const PRICE_SOURCE_LABEL: Record<DualCtaVipStripePriceSource, string> = {
  ab_slot: "A/B slot",
  country_admin: "admin país",
  dashboard: "dashboard/planes",
  canonical: "baseline Exclusive Member fallback (prod/price registry)",
  server_lookup: "dashboard/planes (server)",
};

export function buildDualCtaVipPriceTelemetry(input: {
  stripePriceId?: string;
  priceSource: DualCtaVipStripePriceSource;
  fullPriceUsd?: number;
  firstMonthDiscountPercent?: number;
  /** promo_… applied at checkout (admin DualCTA or canonical). */
  stripePromotionCodeId?: string;
}): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  out.vip_stripe_price_source = PRICE_SOURCE_LABEL[input.priceSource];

  if (input.stripePriceId?.startsWith("price_")) {
    out.vip_stripe_price_id = input.stripePriceId;
  } else {
    out.vip_stripe_price_id = "dashboard:plan_tier=vip";
  }

  const promo = input.stripePromotionCodeId?.trim();
  if (promo?.startsWith("promo_")) {
    out.vip_stripe_promotion_code_id = promo;
  }

  const full = input.fullPriceUsd;
  if (full != null && Number.isFinite(full) && full > 0) {
    out.vip_display_full_usd = Math.round(full * 100) / 100;
    out.vip_billing_monthly_usd = out.vip_display_full_usd;
  }

  const disc = input.firstMonthDiscountPercent;
  if (disc != null && Number.isFinite(disc) && disc > 0) {
    const pct = Math.round(disc);
    out.vip_first_month_discount_percent = pct;
    out.vip_coupon_hint = formatCouponHint(pct, promo);
    if (full != null && full > 0) {
      out.vip_price_offer_line = formatDualCtaFirstMonthOffer(full, pct).shortLine;
    }
  } else if (full != null && full > 0) {
    out.vip_price_offer_line = `$${full % 1 === 0 ? full.toFixed(0) : full.toFixed(2)}/mo`;
  } else if (promo?.startsWith("promo_")) {
    out.vip_coupon_hint = formatCouponHint(0, promo);
  }

  return out;
}
